import get from 'lodash/get';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../../utils/redux';

import { consts as editUserConsts } from '../../profiles/edit-user';
import { consts as editPatientConsts } from '../../profiles/edit-patient';
import { consts as applyGuarantor } from '../../guarantor-information/requests/apply-guarantor-req';
import { consts as editPatientEmergencyContactConsts } from '../../profiles/edit-patient-emergency-contact';
import { PAPERWORK } from '../../../constants/routes';

export const consts = createReqConsts('paperwork', 'user-details', [
  'SET_USER_DETAILS',
]);

export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'profiles',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});

const defaultRequestReducer = createReqReducer(consts);

export default function(state = initialState, action) {
  switch (action.type) {
    case consts.SET_USER_DETAILS: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case applyGuarantor.SUCCEED: {
      const { pathname } = window.location;

      if (pathname.includes(PAPERWORK)) {
        return {
          ...state,
          primaryPatientProfile: {
            ...state.primaryPatientProfile,
            guarantorUser: {
              ...state.primaryPatientProfile.guarantorUser,
              ...action.payload,
            },
          },
        };
      }
    }

    case editPatientEmergencyContactConsts.SUCCEED:
    case editPatientConsts.SUCCEED:
    case editUserConsts.SUCCEED: {
      const payloadUserId = get(action, 'payload.id', null);

      const userId = get(state, 'id', null);

      if (userId && payloadUserId === userId) {
        return {
          ...state,
          ...action.payload,
        };
      }

      return state;
    }

    default: {
      return defaultRequestReducer(state, action);
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/paperwork/requests/paperwork-get-user-details.js